export default __webpack_public_path__ + "static/media/91XAS7_notice01.9ba75ff5.pdf";